import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import store from '@/store'

// let url = "http://13.13.2.58:5000/api/";
let url = "http://www.scyokj.com/yygrjcpt/api/";
// let url = "http://120.79.149.194:8086/yygrjcpt/api/";
const service = axios.create({
  baseURL: url,
  // timeout: 5000, // request timeout
});
sessionStorage.setItem("baseURL", url);

// 回复拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.status === "ok") {
      return res;
    } else if (res.status === "error") {
      Message({
        message: res.msg,
        type: "warning",
        duration: 5 * 1000,
      });
      return res;
    } else {
      return res;
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: "warning",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js